import PropTypes from "prop-types";
import React from "react";
import { toast } from "react-toastify";
import { ButtonField } from "./ButtonField";
import { validateString } from "../Utils/StringUtils";
import "./FieldBase.css"; // #region FONCTION COMPOSANT

/**
 * Composant de base pour les champs de saisie. <br/>
 * Il peut afficher une icône et du texte
 * @class
 * @category Fields
 * @param {Fields.FieldBase.propTypes} props Les propriétés du champ
 */

function FieldBase(props) {
  // Récupération des props
  var alert = props.alert,
      icon = props.icon,
      iconOnTop = props.iconOnTop,
      keepSpaceIcon = props.keepSpaceIcon,
      msgAlert = props.msgAlert,
      obligatory = props.obligatory,
      onChange = props.onChange,
      onClickIcon = props.onClickIcon,
      onMouseEnterIcon = props.onMouseEnterIcon,
      render = props.render,
      textColor = props.textColor,
      tooltip = props.tooltip,
      width = props.width; // Fonction appelée lors du changement de valeur

  var handleChange = function handleChange(event) {
    var target = event.target;

    if (target) {
      var value = target.type === "checkbox" ? target.checked // attribut checked pour les checkbox
      : target.type === "number" && !validateString(target.value) ? 0 // On renvoit 0 pour les input de type number
      : target.type === "date" && !validateString(target.value) ? null // On renvoit null pour les dates vides
      : target.type === "select-one" && !validateString(target.value) ? null // On renvoit null pour les select si pas de sélection
      : target.type === "radio" || target.type === "select-one" ? parseInt(target.value) // On renvoit un entier pour les radio et les select
      : target.value;

      if (onChange) {
        onChange(target.name, value);
      }
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "FieldBase-Container",
    style: {
      minWidth: width,
      maxWidth: width
    }
  }, (icon || keepSpaceIcon) && /*#__PURE__*/React.createElement("div", {
    className: iconOnTop ? "FieldBase-IconContainer FieldBase-IconContainerTop" : "FieldBase-IconContainer"
  }, icon && /*#__PURE__*/React.createElement("i", {
    className: "FieldBase-Icon fas fa-" + icon,
    style: {
      color: textColor,
      cursor: onClickIcon || onMouseEnterIcon ? "pointer" : "default"
    },
    "data-tip": tooltip,
    "data-for": "DefaultTooltip",
    onClick: onClickIcon,
    onMouseEnter: onMouseEnterIcon
  })), alert && /*#__PURE__*/React.createElement("div", {
    className: "FieldBase-AlertButton"
  }, /*#__PURE__*/React.createElement(ButtonField, {
    iconSize: "0.8em",
    widthButtonIcon: "22px",
    heightButtonIcon: "22px",
    tooltip: msgAlert,
    iconColor: "#eee",
    backgroundColor: "#aa0000",
    icon: "exclamation",
    onClick: function onClick() {
      toast.info(msgAlert);
    },
    alert: true
  })), /*#__PURE__*/React.createElement("div", {
    className: obligatory ? "FieldBase-FieldContainer FieldBase-FieldRequired" : "FieldBase-FieldContainer FieldBase-FieldNotRequired"
  }, render(handleChange)));
} // #endregion
// #region PROPRIETES

/**
 * Type des propriétés de {@link FieldBase}
 * @typedef {Object} FieldBase.propTypes
 * @property {string} name Le nom du champ
 * @property {string} tooltip Le descriptif du champ
 * @property {function} onChange La fonction de callback de l'évènement onChange
 * @property {function} render La fonction de rendu
 * @property {string} [backgroundColor=#fff] La couleur de fond
 * @property {string} [textColor=#000] La couleur du texte
 * @property {string} [width=100%] La largeur du champ
 * @property {string} [icon=null] L'icône à afficher
 * @property {boolean} [iconOnTop=false]
 * @property {boolean} [keepSpaceIcon=false] true pour maintenir un écart vide si pas d'icône lorsqu'on empile des champs
 * @property {function} [onClickIcon=null] La fonction de callback de l'évènement onClick de l'icône
 * @property {function} [onMouseEnterIcon=null] La fonction de callback de l'évènement onMouseEnterIcon
 * @property {boolean} [obligatory=false] true si le champ est obligatoire
 * @property {boolean} [readonly=false] true si le champ est désactivé
 * @property {boolean} [alert=false] true si l'on veut afficher une icône d'alerte
 * @property {boolean} [msgAlert=""] Message d'alerte à afficher quand alert vaut true
 */


FieldBase.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  render: PropTypes.func.isRequired,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  width: PropTypes.string,
  icon: PropTypes.string,
  iconOnTop: PropTypes.bool,
  keepSpaceIcon: PropTypes.bool,
  onClickIcon: PropTypes.func,
  onMouseEnterIcon: PropTypes.func,
  obligatory: PropTypes.bool,
  readonly: PropTypes.bool,
  alert: PropTypes.bool,
  msgAlert: PropTypes.string
} : {};
/*
  Valeurs par défaut des propriétés
*/

FieldBase.defaultProps = {
  backgroundColor: "#fff",
  textColor: "#000",
  width: "100%",
  icon: null,
  iconOnTop: false,
  keepSpaceIcon: false,
  onClickIcon: null,
  onMouseEnterIcon: null,
  obligatory: false,
  readonly: false,
  alert: false,
  msgAlert: ""
}; // #endregion

export { FieldBase };